import request from '../request'
import prepareCart from '../lib/prepareCart'

export default {
  namespaced: true,
  state: {
    loading: false,
    loaded: false,
    list: []
  },

  mutations: {
    setLoading(state, v) {
      state.loading = v
    },
    setLoaded(state, v) {
      state.loaded = v
    },
    setList(state, list) {
      state.list = list
    }
  },
  actions: {
    list(context) {
      return new Promise((resolve) => {
        const cart = context.rootState.cart.form
        const { app } = context.rootState
        context.commit('setLoading', true)
        context.commit('setLoaded', false)
        const url = `${app.API_URL}${context.rootState.language}/${app.endpoints.CHECKOUT_SUGGEST}`
        request.make(
          {
            type: 'POST',
            url,
            data: { cart: { ver: 1.0, items: prepareCart(cart) } }
          },
          (err, res) => {
            context.commit('setLoading', false)
            if (res.status === 200) {
              context.commit('setList', res.body.data)
              context.commit('setLoaded', true)
            }
            resolve()
          }
        )
      })
    }
  }
}
